// BussAwards.js
import './css/mycss.css';
import { Cards } from './Cards.js';

import img1 from './images/b1.png';
import img2 from './images/b2.png';
import img3 from './images/b3.png';
import img4 from './images/b4.png';
import img5 from './images/b5.png';
import img6 from './images/b6.png';

/* ----------------- Export Data For Global Search ----------------- */

export const businessAwardsData = [
  {
    category: "Business",
    htext: "EY Entrepreneur of the Year",
    ptext: "Award celebrating visionary leadership and entrepreneurship in India.",
    img1,
    ialt: "EY Entrepreneur of the Year",
    modalContent: `
      <b>Established:</b>1999</br>
              <b>Type:</b>Private National Business Award<br/>
              <b>First Awarded:</b>1999</br>
              <b>First Recipient: </b>N. R. Narayana Murthy (Infosys)</br>
              <b> Symbolism:</b>Celebrates vision, leadership and risk-taking that scale businesses.</br>
              <b> Awarded For:</b>Outstanding entrepreneurship across multiple sectors.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/EY_Entrepreneur_of _the_Year_Award'>wiki link</a></b> 
    `
  },
  {
    category: "Business",
    htext: "CNBC-TV18 India Business Leader Awards",
    ptext: "Recognises influential corporate leaders shaping India’s economy.",
    img1: img2,
    ialt: "India Business Leader Awards",
    modalContent: `
      <b>Established:</b>2004</br>
              <b>Type:</b>Media-led National Business Award<br/>
              <b>First Awarded:</b>2004</br>
              <b>First Recipient: </b> People Interactive (I) Pvt. Ltd.</br>
              <b> Symbolism:</b>Highlights influence, strategy and responsible leadership.</br>
              <b> Awarded For:</b>Leadership, performance and contribution to national economic growth.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/CNBC_TV18'>wiki link</a></b> 
    `
  },
  {
    category: "Business",
    htext: "FICCI India Business Awards",
    ptext: "Industry recognition for innovation, sector transformation and growth.",
    img1: img3,
    ialt: "FICCI India Business Awards",
    modalContent: `
      <b>Established:</b>2004</br>
              <b>Type:</b>National Industry Association Award<br/>
              <b>First Awarded:</b>2004</br>
              <b>First Recipient: </b>ACC Limited,ITC Limited</br>
              <b> Symbolism:</b>Represents industry advancement and responsible growth.</br>
              <b> Awarded For:</b>Innovation, competitiveness, sustainability and sector leadership.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Federation_of_Indian_Chambers_of_Commerce_&_Industry'>wiki link</a></b>
    `
  },
  {
    category: "Business",
    htext: "National Entrepreneurship Awards",
    ptext: "Government recognition for outstanding young entrepreneurs & startups.",
    img1: img4,
    ialt: "National Entrepreneurship Awards",
    modalContent: `
      <b>Established:</b>2016</br>
              <b>Type:</b>Government Award<br/>
              <b>First Awarded:</b>2016</br>
              <b>First Recipient: </b>Wow Momo Foods Private Ltd,</br>Saral Design Solutions Private Limited,</br>Swadha Energies</br>
              <b> Symbolism:</b>Represents youth-driven innovation and enterprise building.</br>
              <b> Awarded For:</b>Outstanding entrepreneurship and entrepreneurial support.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/National_Entrepreneurship_Awards'>wiki link</a></b> 
    `
  },
  {
    category: "Business",
    htext: "Pravasi Bharatiya Samman Award",
    ptext: "India’s top recognition for overseas Indians contributing to nation-building.",
    img1: img5,
    ialt: "Pravasi Bharatiya Samman Award",
    modalContent: `
      <b>Established:</b>2003</br>
              <b>Type:</b>Government Honor<br/>
              <b>First Awarded:</b>2003</br>
              <b>First Recipient: </b>Ujjal Dosanjh: From Canada.<br>Dr. Hari N. Harilela: From Hong Kong.<br>Rajat Gupta: From the United States.</br>
              <b> Symbolism:</b>Represents global Indian excellence and contribution to India’s growth.</br>
              <b> Awarded For:</b>Business leadership, investment, innovation and community contribution abroad.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Pravasi_Bharatiya_Samman_Award'>wiki link</a></b> 
    `
  },
  {
    category: "Business",
    htext: "AIMA Managing India Awards",
    ptext: "Award for excellence in strategic management & leadership.",
    img1: img6,
    ialt: "AIMA Managing India Awards",
    modalContent: `
      <b>Established:</b>2010</br>
              <b>Type:</b>National Management Award<br/>
              <b>First Awarded:</b>2010</br>
              <b>First Recipient: </b>Ratan N. Tata</br>
              <b> Symbolism:</b>Highlights strategic thinking, management excellence and nation-building.</br>
              <b> Awarded For:</b>Corporate leadership, management excellence and transformative impact.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/All_India_Management_Association'>wiki link</a></b> 
    `
  }
];

/* ----------------- Page Component ----------------- */

export default function BussAwards() {
  return (
    <div>
      <h1 className="heading">Business Awards</h1>
      <h3 className="head2">Honouring the leaders shaping India’s business future.</h3>

      <div className="search-cards-container">
        {businessAwardsData.map((award, i) => (
          <Cards
            key={i}
            htext={award.htext}
            ptext={award.ptext}
            img1={award.img1}
            ialt={award.ialt}
            btext="learn more"
            modalContent={award.modalContent}
          />
        ))}
      </div>
    </div>
  );
}
